/**
 * Single source of truth for "is this the delivery-company users screen?".
 *
 * The users screen (src/pages/user/index.vue) and its dialogs are shared
 * between regular company/restaurant employees and delivery-company employees.
 * They use the same layout but hit different endpoints (`/users` vs
 * `/users-delivery`) and offer different roles.
 *
 * The context lives on the route: the dedicated `firma-dostava-id-korisnici`
 * route carries `meta.deliveryUsers === true`, so it survives a page refresh
 * or a deep link.
 */
export default {
  computed: {
    isDeliveryUsersContext() {
      return this.$route.meta.deliveryUsers === true;
    },
  },
};
